module.exports = __webpack_public_path__ + "img/adultmilk.26dd7488.png";